/** Barra superior fixa: logo/voltar ao sistema, busca global, toggle do drawer. */
export function TopBar({
  query,
  onQuery,
  onClear,
  onHome,
  onToggleNav,
  showNavToggle,
}: {
  query: string;
  onQuery: (v: string) => void;
  onClear: () => void;
  onHome: () => void;
  onToggleNav: () => void;
  showNavToggle: boolean;
}) {
  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-3">
        {showNavToggle ? (
          <button
            onClick={onToggleNav}
            className="md:hidden w-10 h-10 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center text-slate-600 hover:text-slate-900 transition shrink-0"
            aria-label="Abrir menu"
          >
            <i className="fas fa-bars" />
          </button>
        ) : null}

        <button onClick={onHome} className="flex items-center gap-2 shrink-0 group" title="Central de Ajuda">
          <div className="w-9 h-9 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform">
            <i className="fas fa-question-circle" />
          </div>
          <span className="hidden sm:block font-black text-slate-900 tracking-tight">Central de Ajuda</span>
        </button>

        {/* Busca global */}
        <div className="flex-1 max-w-xl mx-auto relative">
          <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
          <input
            type="text"
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            placeholder="Buscar tutorial… (ex: motoboy, caixa, combo)"
            className="w-full bg-gray-100 border border-gray-200 rounded-xl pl-12 pr-10 py-2.5 text-sm text-slate-800 placeholder-slate-400 outline-none focus:bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 transition"
          />
          {query ? (
            <button
              onClick={onClear}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 transition"
              aria-label="Limpar busca"
            >
              <i className="fas fa-times-circle" />
            </button>
          ) : null}
        </div>

        <a
          href="/admin/dashboard"
          className="hidden md:flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 transition shrink-0"
        >
          <i className="fas fa-arrow-left" /> Voltar ao sistema
        </a>
      </div>
    </nav>
  );
}
